<script>
export default {
  name: 'DotComponent',
  components: {},
  props: {
    index: { type: Number, required: true, default: 0 },
    isActive: { type: Boolean, required: true, default: false },
    slidesLength: { type: Number, required: true, default: 0 },
    prefixAriaLabel: { type: String, required: false, default: 'slide' },
    filmstripId: { type: String, required: false, default: 'filmstrip-1' },
  },
};
</script>

<template>
  <button
    :id="`${filmstripId}-dot-${index}`"
    :class="[
      'filmstrip-dot',
      {'filmstrip-dot--active': isActive}
    ]"
    :data-analytics-id="`slide-dot-${index}`"
    :aria-label="`${prefixAriaLabel} ${index} of ${slidesLength}`"
    tabindex="0"
  />
</template>

<style lang="scss" scoped>
@import "@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss";

.filmstrip-dot {
  background-color: transparent;
  border-radius: 50%;
  border: 0.5px solid #928B80;
  cursor: pointer;
  display: inline-block;
  height: 16px;
  margin-left: $cdr-space-three-quarter-x;
  outline-color: $cdr-color-border-info;
  padding: 0;
  width: 16px;

  &:first-child {
    margin-left: 0;
  }

  &--active {
    background-color: #4E4D49;
    border: none;
  }
}
</style>
